import React from "react";

import { Link } from "react-router-dom";

import Table from "../../common/Table";
import RowPhoto from "../../common/TdImg";

const FacultiesSalariesList = ({ data, query }) => {
  const renderLink = (e) => {
    return (
      <Link
        to={`/mis/teachers/${e.teacher_id}/profile/salary?teacherName=${e.teacher_name}`}
      >
        {e.teacher_name}
      </Link>
    );
  };

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "teacher_photo",
      label: "عکس",
      content: ({ teacher_photo }) => <RowPhoto src={teacher_photo} />,
    },
    {
      path: "aria_id",
      label: "کد استاد",
    },
    {
      path: "teacher_name",
      label: "نام",
      content: (e) => renderLink(e),
    },
    {
      path: "salary_per_hour",
      label: "فی کریدت",
    },
    {
      path: "total_count",
      label: "حاضر",
    },
    {
      path: "salary_before_tax",
      label: "معاش",
    },
    {
      path: "salary_tax",
      label: "مالیه",
    },
    {
      path: "payable",
      label: "قابل پرداخت",
    },
    {
      path: "paid",
      label: "پرداخت شده",
    },
    {
      path: "half_year_balance",
      label: "باقیمانده",
    },
    {
      path: "overall_balance",
      label: "باقیمانده کل",
    },

    { path: "option" },
  ];

  return <Table data={data} query={query} columns={columns} />;
};

export default FacultiesSalariesList;
